'use client'

import { CSSProperties, forwardRef } from 'react'

interface Props {
  src: string
  className?: string
  style?: CSSProperties
}

/**
 * Presentational <iframe> that hosts the external Yandex map micro-app.
 * All protocol logic lives in `useMapBridge` — this component just renders
 * the frame and forwards the ref it needs.
 */
const YandexMapFrame = forwardRef<HTMLIFrameElement, Props>(
  ({ src, className, style }, ref) => (
    <iframe
      ref={ref}
      src={src}
      className={className}
      allow='geolocation'
      style={{ border: 'none', width: '100%', height: '100%', ...style }}
    />
  )
)

YandexMapFrame.displayName = 'YandexMapFrame'

export default YandexMapFrame
